import { registerMockAPI } from '~/mocks/mockApis';

import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';
import { transformToSelectOptions } from '~/utils/common';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { GetCollectingRequestCandidatesSearchConditionsResponse } from '~/types/delivery-agency.types';

export const fetchCollectingRequestCandidatesSearchConditions = async () => {
  const { data } = await axiosInstance.get<GetCollectingRequestCandidatesSearchConditionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_CANDIDATES_CODES
  );
  return data.data;
};

type UseGetCollectingRequestCandidatesSearchConditionsQueryOptions = {
  enabled?: boolean;
  showGlobalErrorToast?: boolean;
};

export const useGetCollectingRequestCandidatesSearchConditionsQuery = (
  options?: UseGetCollectingRequestCandidatesSearchConditionsQueryOptions
) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.collectingRequestCandidatesSearchConditions(),
    queryFn: fetchCollectingRequestCandidatesSearchConditions,
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 30,
    meta: { showGlobalErrorToast: options?.showGlobalErrorToast ?? true },
    select: (data) => ({
      searchKeywordTypes: transformToSelectOptions(data.searchKeywordTypes, 'code', 'description'),
    }),
  });
};

registerMockAPI<GetCollectingRequestCandidatesSearchConditionsResponse>({
  method: 'get',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_CANDIDATES_CODES,
  label: '배송 주문 반품 신청·조회/반품 신청 후보 검색조건',
  scenarios: [
    {
      name: '정상 응답',
      response: {
        data: {
          searchKeywordTypes: [
            { code: 'OUTBOUND_CODE', description: '출고번호' },
            { code: 'CLIENT_ORDER_CODE', description: '판매처 주문번호(원주문)' },
            { code: 'SHIPPING_LABEL_NUMBER', description: '운송장번호' },
            { code: 'RECEIVER_NAME', description: '원주문 수령자명' },
            { code: 'ORDERER_NAME', description: '원주문 주문자명' },
          ],
        },
      },
    },
    {
      name: '서버 에러 (500)',
      status: 500,
      response: { data: { searchKeywordTypes: [] } },
    },
  ],
});
